import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
interface WindowSize {
  width: number | undefined;
  height: number | undefined;
}
export const useWindowSize = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: undefined,
      height: undefined
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [windowSize, setWindowSize] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return windowSize;
};